// extracted by mini-css-extract-plugin
export var header = "_vi-1";
export var maskBottom = "_vi-6";
export var maskMiddle = "_vi-7";
export var maskTop = "_vi-5";
export var root = "_vi-0";
export var scrollDownButton = "_vi-3";
export var scrollDownButtonHidden = "_vi-4";
export var viewport = "_vi-2";